export default "__VITE_ASSET__CZ69XosJ__"